import React, { ReactElement, useContext, useState } from 'react'
import { Context } from '@/components/Context'
import Button from '@/components/Button'
import { PersonalWallet } from '@/database/personalwallet'

const TransferToken = ({ wallet }: { wallet: PersonalWallet }): ReactElement => {
    const { accountSignature, proxyTransferToken } = useContext(Context)
    const [amount, setAmount] = useState('')
    const [address, setAddress] = useState('')
    const [recipient, setRecipient] = useState('')

    const transactionHandler = async (event: { preventDefault: () => void }) => {
        event.preventDefault()
        if (!amount || !address || !recipient) {
            window.alert('Please fill all the fields')
            return
        }
        if (!accountSignature) {
            window.alert('Please connect your wallet to proceed transaction')
            return
        }
        if (!wallet) {
            window.alert('Wallet not found')
            return
        }
        await proxyTransferToken(wallet.address, address, recipient, amount)
    }

    const handleAddressInputChange = (event: { target: { value: string } }) => {
        setAddress(event.target.value)
    }

    const handleReceiverInputChange = (event: { target: { value: string } }) => {
        setRecipient(event.target.value)
    }

    const handleAmountInputChange = (event: { target: { value: string } }) => {
        const input = event.target.value.replace(',', '.') // Normalize input

        // Check if the last character is a dot or if the input is just a dot
        const endsWithDot = input.endsWith('.') || input === '.'

        // Use a regular expression to validate if the input is in a correct numeric format (including dots)
        const isValidNumericInput = /^(\d+\.?\d*|\.\d+)$/.test(input)

        if (endsWithDot || isValidNumericInput) {
            // Directly update the state with the input if it's a valid numeric input or ends with a dot
            const newInput = parseFloat(input)
            setAmount(newInput.toString())
        } else if (input === '') {
            setAmount('')
        }
    }

    return (
        <div className="form ">
            <div className="artwork-box padding-five">
                <form onSubmit={transactionHandler} className={'bottom2'}>
                    <div>Token Address</div>
                    <div className={'flex-row form-as-class align-right'}>
                        <input
                            className="width335"
                            placeholder={`... Contract Address ...`}
                            value={address}
                            onChange={handleAddressInputChange}
                        />
                    </div>
                    <div>Receiver</div>
                    <div className={'flex-row form-as-class align-right'}>
                        <input
                            className="width335"
                            placeholder="... Receiver Address ..."
                            value={recipient}
                            onChange={handleReceiverInputChange}
                        />
                    </div>
                    <div>Amount</div>
                    <input
                        className="width250"
                        type="number"
                        min={0}
                        placeholder="... Amount to send ..."
                        value={amount}
                        onChange={handleAmountInputChange}
                    ></input>
                    <Button
                        btnName={`Send`}
                        classStyles={'nav__medium center bottom'}
                        disabled={!accountSignature || !wallet || !address || !amount || !recipient}
                        handleClick={(event: { preventDefault: () => void }) =>
                            accountSignature
                                ? transactionHandler(event)
                                : alert('Please connect your wallet to proceed transaction')
                        }
                        cancelBg={undefined}
                    />
                </form>
            </div>
        </div>
    )
}
export default TransferToken
